import inject from "scripts/ioc/inject";
import BaseContentDetailsPageView from "scripts/views/baseContentDetailsPageView";
import ContentDetailsArticlePageNavView from "scripts/views/contentDetailsArticlePageNavView";

import templateContentDetailsArticlePage from "templates/contentDetailsArticlePage.hbs";

class ContentDetailsArticlePageView extends BaseContentDetailsPageView {
  constructor(
    options,
    breadcrumbService = inject("breadcrumbService"),
    connectionService = inject("connectionService"),
    securityService = inject("securityService"),
    bookshelfService = inject("bookshelfService"),
  ) {
    super(
      options,
      breadcrumbService,
      connectionService,
      securityService,
      bookshelfService,
    );

    this.initializeBookshelfDeps();
  }

  get template() {
    return templateContentDetailsArticlePage;
  }

  render() {
    super.render();
    super.renderBookshelfElements();

    return this;
  }

  createNavView() {
    const organizationProperties = this.securityService.getUser().getActiveOrganizationProperty(
        "organizationProperties",
    );

    return new ContentDetailsArticlePageNavView({
      model: this.model,
      organizationProperties,
    });
  }
}

export default ContentDetailsArticlePageView;
